import * as React from "react";

interface IBellSvgProps {
	width: string;
	height: string;
	viewbox: string;
}

export function BellSvg(props: IBellSvgProps): JSX.Element {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			id="prefix__Component_32_1"
			width={props.width}
			height={props.height}
			data-name="Component 32 – 1"
			viewBox={props.viewbox}
		>
			<defs>
				<style>{`.bell-2{fill:#f5690f}.bell-3{fill:none;stroke-width:3px;stroke:#173f80}`}</style>
			</defs>
			<circle id="prefix__Ellipse_112" cx="62.5" cy="62.5" r="62.5" fill="#f5690f" data-name="Ellipse 112" opacity="0.1" />
			<g id="prefix__noun_notification_2184962" transform="translate(36.965 34.715)">
				<g id="prefix__Group_4681" data-name="Group 4681">
					<g id="prefix__Group_4680" data-name="Group 4680">
						<path
							id="prefix__Path_1423"
							d="M69.271 54.238a5.412 5.412 0 1 1-.008 10.824H29.922a5.412 5.412 0 1 1-.008-10.824.494.494 0 0 0 .49-.494V41.938a19.188 19.188 0 0 1 38.377 0v11.807a.488.488 0 0 0 .49.493zm0 2.952a3.44 3.44 0 0 1-3.442-3.446V41.938a16.236 16.236 0 0 0-32.473 0v11.807a3.446 3.446 0 0 1-3.442 3.446 2.46 2.46 0 1 0 .008 4.92h39.341a2.46 2.46 0 1 0 .008-4.92z"
							className="bell-2"
							data-name="Path 1423"
							transform="translate(-24.5 -22.75)"
						/>
					</g>
				</g>
			</g>
			<path
				id="prefix__Subtraction_1"
				d="M6.937 7.415A7.186 7.186 0 0 1 0 .017V0h13.872v.017a7.186 7.186 0 0 1-6.935 7.398z"
				className="bell-3"
				data-name="Subtraction 1"
				transform="translate(55.122 79.489)"
			/>
			<path
				id="prefix__Path_1425"
				d="M-10826.424 7812.3c0-3.148 2.844-17.039 17.291-17.039"
				className="bell-3"
				data-name="Path 1425"
				transform="translate(10864.938 -7763.24)"
			/>
			<path
				id="prefix__Path_1427"
				fill="none"
				stroke="#f5690f"
				strokeWidth="3px"
				d="M-10826.424 7807.792c0-2.319 2.092-12.532 12.716-12.532"
				data-name="Path 1427"
				transform="translate(10875.764 -7754.384)"
			/>
			<path
				id="prefix__Path_1426"
				d="M0 17.04C0 13.892 2.843 0 17.292 0"
				className="bell-3"
				data-name="Path 1426"
				transform="rotate(90 27.638 59.531)"
			/>
			<path id="prefix__Rectangle_1065" d="M0 0H3V3H0z" className="bell-2" data-name="Rectangle 1065" transform="translate(48 55)" />
		</svg>
	);
}
export default BellSvg;
